/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCollapseCVClosedIcon24Regular = forwardRef('ArrowCollapseCVClosedIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M13.68 10.058a2.375 2.375 0 0 1-3.36 0l-5.689-5.69A.875.875 0 1 1 5.87 3.132l5.689 5.69c.244.244.64.244.884 0l5.689-5.69a.875.875 0 1 1 1.237 1.238l-5.689 5.689Z" }),
        React.createElement("path", { d: "M13.68 13.942a2.375 2.375 0 0 0-3.36 0l-5.689 5.69a.875.875 0 1 0 1.238 1.237l5.689-5.69a.625.625 0 0 1 .884 0l5.689 5.69a.875.875 0 1 0 1.237-1.238l-5.689-5.689Z" })));
});
